import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { usePermissions } from '../../hooks/usePermissions';
import { getOAuthConnectUrl } from '../../store/slices/googleReviewSlice';
import GoogleReviewConnectCard from './GoogleReviewConnectCard';

const GoogleReviewReconnectBanner: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const needsReconnect = useAppSelector((state) => state.googleReview.needsReconnect);
  // Subuser: reconnecting the Google account (OAuth) requires google_review_write.
  const { can } = usePermissions();
  const canWrite = can('google_review_write');
  const [isConnecting, setIsConnecting] = useState(false);

  if (!needsReconnect) {
    return null;
  }

  const handleReconnect = async () => {
    setIsConnecting(true);
    try {
      const result = await dispatch(getOAuthConnectUrl()).unwrap() as { url: string };
      if (result.url && result.url !== '#mock-oauth') {
        window.location.href = result.url;
      }
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <GoogleReviewConnectCard
      className="google-review-connect-card--banner"
      role="alert"
      title={t('google_review_reconnect_title')}
      description={t('google_review_reconnect_description')}
      buttonLabel={t('google_review_reconnect_button')}
      loadingLabel={t('loading_text')}
      onConnect={handleReconnect}
      isConnecting={isConnecting}
      disabled={!canWrite}
      disabledTitle={t('subuser_no_permission_tooltip')}
    />
  );
};

export default GoogleReviewReconnectBanner;
